<div class="container">
    <p-tabs 
    showNavigators="false"
    [value]="activeIndex" 
    [dt]="tabMenu" 
    [style]="{ width: '100%', height: '100%' }">
        <p-tablist [style]="{ 'width': '100%' }">
            @for (tab of tabItems; track tab.id) {
                <a [routerLink]="tab.route" 
                [style]="{'width': '50%', 'height': '100%', 'text-decoration': 'none' }">
                    <p-tab [value]="tab.id" [style]="{ 'justify-content': 'center'}">
                        <span>{{ tab.label }}</span>
                    </p-tab>
                </a>
            }
        </p-tablist>
    </p-tabs>
</div>